import React, { useState, useEffect } from 'react';
import './Reclubbing.css';
import axios from 'axios';
import { Link } from 'react-router-dom';

function Reclubbing() {
  const [reclubbingImages, setReclubbingImages] = useState([]);
  const [reclubbingCategory, setReclubbingCategory] = useState(null);

  useEffect(() => {
    axios
      .get(`/api/v1/category/`)
      .then((response) => {
        const categories = response.data;
        // Find the "Re-clubbing" category
        const reclubbingCategory = categories.find(
          (category) => category.name.toLowerCase() === 're-clubbing'
        );

        if (reclubbingCategory && reclubbingCategory.reclubbing_images) {
          // Set images from the reclubbing_images array
          setReclubbingImages(reclubbingCategory.reclubbing_images);
          setReclubbingCategory(reclubbingCategory);
        }
      })
      .catch((error) => {
        console.error('Error fetching Re-clubbing images:', error);
      });
  }, []);

  return (
    <div className="reclubbing">
      <div className="reclubbing-images">
        {reclubbingImages.map((image) => (
         <div key={image.id} className="reclubbing-image-wrapper">
            <Link to={`/category/${reclubbingCategory.slug}`}>

              {/* Default Image */}
              <img
                src={image.image}
                alt={`Reclubbing ${image.id}`}
                className="img-default"
              />

              {/* Hover Image (if it exists) */}
              {image.hover_image && (
                <img
                  src={image.hover_image}
                  alt={`Reclubbing hover ${image.id}`}
                  className="img-hover"
                />
              )}

            </Link>
          </div>
        ))}
      </div>
      {reclubbingCategory && (
        <div className="card_title">
          <Link to={`${reclubbingCategory.get_absolute_url}`}>
            <h1>{reclubbingCategory.name}</h1>
          </Link>
        </div>
      )}
    </div>
  );
}

export default Reclubbing;
